import {useState} from "react";
import {faCaretDown, faCaretUp} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library as fontAwesomeLibrary} from "@fortawesome/fontawesome-svg-core";


/**
 * Shows a block of text with "See More" and "See Less" links, defined
 * by a number of words and lines to show before truncation.
 *
 * @param props.text Text to display.
 * @param props.showWordCount Number of words to show before truncation (default 50);
 * @param props.showLineCount Number of line to show before truncation (default 3);
 * @return JSX element
 */
export function ExpandableText(props) {
    const {text} = props;
    const showWordCount = props.showWordCount || 50;
    const showLineCount = props.showLineCount || 3;

    const [expand, setExpand] = useState(false);

    let textContent = text;


    const wordCount = text.split(" ").length;
    const lineCount = textContent.split("\n").length;

    let needsTruncate = wordCount > showWordCount || lineCount > showLineCount;
    let truncated = false;

    if (needsTruncate && ! expand) {
        const instToks = text.split(" ");

        textContent = (
            instToks
                .slice(0, showWordCount)
                .join(" ")
        );
        textContent = (
            textContent.split("\n")
                .slice(0, showLineCount)
                .join("\n")
        );
        textContent += "...";

        truncated = true;
    }

    fontAwesomeLibrary.add(faCaretDown);
    fontAwesomeLibrary.add(faCaretUp);

    const linkStyle = {color: "#2290BF", cursor: "pointer"};

    return (
        <div>
          {textContent
           .split('\n')
           .map((line, i) => {return <span key={i+600}>{line}<br /></span>})}
          {truncated ?
           <span
             onClick={() => setExpand(true)}
             style={linkStyle}>
             <FontAwesomeIcon icon={faCaretDown} />
             &nbsp;
             See More
           </span>
           : ""}
          {needsTruncate && !truncated ?
           <span
             onClick={() => setExpand(false)}
             style={linkStyle}>
             <FontAwesomeIcon icon={faCaretUp} />
             &nbsp;
             See Less
           </span> : ""}
        </div>
    );
}
